export const SCROLL_LOAD_MORE_THRESHOLD = 80;
